import React from 'react';
import {
  PartialBy,
  DigitalSubmissionChoiceWithText,
  QuestionSingleChoiceWithText,
} from '../../../redux/types';
import ChoiceTextQuestionInput from '../ChoiceTextQuestionInput';
import { QuestionSaveOp } from '../../../hooks/survey/useQuestionSaveStatus';

export type Props ={
  question: QuestionSingleChoiceWithText;
  sectionId?: number;
  enrollmentId?: number;
  caseId?: number;
  disabled?: boolean;
  onSave?: (vals?: PartialBy<DigitalSubmissionChoiceWithText<QuestionSingleChoiceWithText['type']>, 'id'>) => Promise<void>;
  defaultSubmission?: DigitalSubmissionChoiceWithText<QuestionSingleChoiceWithText['type']>;
  expand?: boolean;
  summarizedView?: boolean;
  getSaveStatus?: (op: QuestionSaveOp, qId: number, caseId?: number) => void;
  manualSave?: boolean;
  saveOnBlur?: boolean;
}

const SingleChoiceWithTextQuestionInput: React.FC<Props> = ({
  question,
  sectionId,
  enrollmentId,
  caseId,
  disabled,
  defaultSubmission,
  expand,
  summarizedView: summarized,
  onSave,
  getSaveStatus,
  manualSave,
  saveOnBlur,
}: Props) => (
  <ChoiceTextQuestionInput<QuestionSingleChoiceWithText>
    question={question}
    caseId={caseId}
    sectionId={sectionId}
    enrollmentId={enrollmentId}
    disabled={disabled}
    defaultSubmission={defaultSubmission}
    expand={expand}
    summarizedView={summarized}
    onSave={onSave}
    getSaveStatus={getSaveStatus}
    manualSave={manualSave}
    saveOnBlur={saveOnBlur}
  />
);

export default SingleChoiceWithTextQuestionInput;
